import { isString, findKey } from 'lodash';
import { corvidEntities } from '@wix/motion-edm-autogen-transformations-core';
var fromCorvidName = corvidEntities.fromCorvidName;
var renameFieldByPaths = function (transformationPaths, fieldPath) {
    if (!isString(fieldPath)) {
        return fieldPath;
    }
    var transformationPath = findKey(transformationPaths, function (_, path) { return path === fieldPath || fieldPath.startsWith("".concat(path, ".")); });
    if (transformationPath) {
        return fieldPath.replace(transformationPath, transformationPaths[transformationPath]);
    }
    return fieldPath
        .split('.')
        .map(function (segment) { return transformationPaths[segment] || fromCorvidName(segment); })
        .join('.');
};
export { renameFieldByPaths };
//# sourceMappingURL=renameFieldByPaths.js.map